import React from "react";

const Table = ({ columns, data, emptyIcon, emptyTitle, emptyMessage }) => (
  <div className="card bg-white shadow-sm mx-3">
    <div
      className="card-header border-bottom"
      style={{ borderRadius: "12px 12px 0 0", background: "#f1f2f4" }}
    >
      <h6 className="mb-0" style={{ fontSize: "0.9rem" }}>
        {columns.title || "Table"}
      </h6>
    </div>
    <div className="card-body p-0">
      {data.length === 0 ? (
        <div className="text-center py-5">
          {emptyIcon}
          <h5 className="text-muted mt-3">{emptyTitle}</h5>
          <p className="text-muted">{emptyMessage}</p>
        </div>
      ) : (
        <div
          style={{
            maxHeight: "410px",
            overflowY: "auto",
            overflowX: "auto",
            position: "relative",
          }}
        >
          <table
            className="table table-hover mb-0"
            style={{ borderRadius: "0 0 12px 12px", overflow: "hidden" }}
          >
            <thead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2,
                background: "#f1f2f4",
              }}
            >
              <tr>
                {columns.headers.map((header, idx) => (
                  <th
                    key={idx}
                    className={header.className || "border-0"}
                    style={{
                      color: "#6b7280",
                      fontSize: "14px",
                      ...header.style,
                    }}
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={row.id || idx}>
                  {columns.headers.map((header, hIdx) => (
                    <td
                      key={hIdx}
                      className={header.cellClassName || "ps-4"}
                      style={{
                        fontSize: "14px",
                        textTransform: "capitalize",
                        ...header.cellStyle,
                      }}
                    >
                      {row[header.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);

export default Table;
